module.exports = __webpack_public_path__ + "static/media/TylerDurden.0cfaae0c.jpg";